import { Component } from '@angular/core';

@Component({
  selector: 'app-group-configure-terms',
  templateUrl: './group-configure-terms.component.html',
  styleUrls: ['./group-configure-terms.component.scss']
})
export class GroupConfigureTermsComponent { }
